import { colors } from "../../styles/style";

const style = {
  buttonOption: {
    width: "100%",
    border: 0,
    borderWidth: 1,
    borderColor: colors.GRAY_3_COLOR,
    padding: 0,
    backgroundColor: colors.WHITE_COLOR,
    color: colors.GRAY_2_COLOR,
  },
};

export { style };
